<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="d-flex flex-column flex-root" id="kt_app_root">
  <!--begin::Page bg image-->
  <!--end::Page bg image-->
  <!--begin::Authentication - Signup Welcome Message -->
  <div class="loginpage d-flex flex-column flex-center flex-column-fluid">
    <!--begin::Content-->
    <div class="d-flex flex-column flex-center p-10">
      <!--begin::Wrapper-->
      <div class="card-warp w-md-650px py-5 content-login" [formGroup]="generateRegisterForm">
        <div class="content py-15 py-lg-20">
          <!--begin::Logo-->
          <div class="mb-7 text-center">
            <a href="/" class="">
              <img alt="Logo" src="/assets/media/logos/wegestu.png" class="h-150px logo-login" />
            </a>
          </div>
          <!--end::Logo-->
          <!--begin::Title-->

          <!--end::Text-->
          <!--begin::Illustration-->
          <div class="fv-row mb-8">
            <!--begin::Email-->
            <label for="nom">Nom entreprise <span class="start-required">*</span></label>
            <div class="input-group mb-5">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-user"></i>
              </span>
              <input
                type="text"
                formControlName="name"
                class="form-control"
                placeholder="Nom entreprise"
                aria-label="name"
                aria-describedby="basic-addon1"
                [type]="showName"
                autocomplete="off"
                (blur)="onCompanyNameBlur()"
              />
            </div>

            <div *ngIf="
                generateRegisterForm.get('name')?.hasError('required') &&
                generateRegisterForm.get('name')?.touched
              " class="text-danger">
              Le champ "Nom" est obligatoire .
            </div>
          </div>
          <div class="fv-row mb-8">
            <label for="prenom">linkedin</label>
            <div class="mb-5">
              <div class="input-group mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fa-brands fa-linkedin-in"></i>
                </span>
                <input type="text" formControlName="linkedin_link" class="form-control"
                  (ngModelChange)="setValidatorRequirements()" placeholder=" https://www.linkedin.com/company/"
                  aria-label="linkedin_link" aria-describedby="basic-addon1" />
              </div>
            </div>

            <div *ngIf="
                generateRegisterForm
                  .get('linkedin_link')
                  ?.hasError('pattern') &&
                generateRegisterForm.get('linkedin_link')?.touched
              " class="text-danger">
              Entrer une URL valide exemple:
              https://www.linkedin.com/company/exemple
            </div>
          </div>

          <div class="fv-row mb-8">
            <label for="prenom">Site web</label>
            <div class="input-group mb-5">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-globe"></i>
              </span>
              <input type="text" [type]="showName" formControlName="website_link" class="form-control"
                (ngModelChange)="setValidatorRequirements()"
                placeholder="https://www.exemple.com ou www.exemple.fr "
                aria-label="linkedin_link" aria-describedby="basic-addon1"/>
            </div>

            <div *ngIf="
                generateRegisterForm.get('website_link')?.hasError('pattern') &&
                generateRegisterForm.get('website_link')?.touched
              " class="text-danger">
              Oups ! L’URL semble incorrecte. Essayez avec : https://www.exemple.com ou www.exemple.fr
            </div>

            <div class="info-message">
              <span class="requirements mb-3">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379_198)">
                  <path
                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                    fill="#2b5d8f" />
                </g>
                <defs>
                  <clipPath id="clip0_379_198">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Au moins l'un des champs Site web ou LinkedIn est requis. 
            </span>
            </div>

          </div>
          <!--end::Input group=-->

          <div class="fv-row mb-8">
            <!--begin::Type (Select List)-->
            <label for="select_type">Vous êtes ... <span class="start-required">*</span></label>

            <div class="input-with-icon mb-3" *ngIf="!gettype">
              <i class="fa-solid fa-user-tag"></i>
              <!-- <ng-select formControlName="type" [items]="type" bindLabel="nametype" bindValue="id" [placeholder]=" 'Choisir le type :'" autoComplete [readonly]="false">
                        </ng-select> -->
              <ng-select formControlName="type" [items]="filteredType" bindLabel="nametype" bindValue="id"
                [placeholder]="'Choisir le type :'" (change)="onTypeChange($event)">
              </ng-select>
            </div>
            <div class="input-with-icon mb-3" *ngIf="gettype == '1' || gettype == '2' ">
              <i class="fa-solid fa-user-tag"></i>
              <ng-select (change)="gettypeselect($event)" formControlName="type" [items]="filteredType" bindLabel="nametype"
                bindValue="id" autoComplete>
              </ng-select>
            </div>
            <span *ngIf="gettype == '1' &&  !generateRegisterForm.get('type')?.touched || showmsg" class="text-danger">
              {{ message }}</span>

            <div class="input-with-icon mb-3" *ngIf="gettype == '3' || gettype == '4'">
              <i class="fa-solid fa-user-tag"></i>

              <ng-select formControlName="type" [items]="filteredType" bindLabel="nametype" bindValue="id"
                autoComplete>
              </ng-select>
            </div>
            <div *ngIf="
                generateRegisterForm.get('type')?.hasError('required') &&
                generateRegisterForm.get('type')?.touched
              " class="text-danger">
              Le champ "type entreprise" est obligatoire .
            </div>
          </div>
       
          <div class="fv-row mb-8">
            <label for="prenom">Prénom de l'administrateur <span class="start-required">*</span></label>
            <div class="mb-5">
              <div class="input-group mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fa-solid fa-user"></i>
                </span>
                <input type="text" formControlName="first_name" class="form-control"
                 placeholder="Prénom de l'administrateur" aria-label="first_name" 
                 aria-describedby="basic-addon1"/>
              </div>
            </div>

            <div *ngIf="generateRegisterForm.get('first_name')?.invalid && generateRegisterForm.get('first_name')?.touched" class="text-danger">
              <span *ngIf="generateRegisterForm.get('first_name')?.errors?.['required']">Ce champ est obligatoire.</span>
              <span *ngIf="generateRegisterForm.get('first_name')?.errors?.['pattern']">Pas de caractères spéciaux ou de chiffres autorisés.</span>
            </div>
          </div>

          <div class="fv-row mb-8">
            <label for="nom">Nom de l'administrateur <span class="start-required">*</span></label>
            <div class="mb-5">
              <div class="input-group mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <i class="fa-solid fa-user"></i>
                </span>
                <input type="text" formControlName="last_name" class="form-control"
                 placeholder="Nom de l'administrateur" aria-label="last_name" 
                 aria-describedby="basic-addon1"/>
              </div>
            </div>

            <div *ngIf="generateRegisterForm.get('last_name')?.invalid && generateRegisterForm.get('last_name')?.touched" class="text-danger">
              <span *ngIf="generateRegisterForm.get('last_name')?.errors?.['required']">Ce champ est obligatoire.</span>
              <span *ngIf="generateRegisterForm.get('last_name')?.errors?.['pattern']">Pas de caractères spéciaux ou de chiffres autorisés.</span>
            </div>
          </div>

          <div class="fv-row mb-8">
            <!--begin::Password-->
            <label for="mail">E-mail <span class="start-required">*</span></label>
            <div class="input-group mb-5">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-envelope"></i>
              </span>
              <input type="email" formControlName="email" class="form-control" placeholder="contact@wegestu.com"
                aria-label="mail" aria-describedby="basic-addon1" />
            </div>

            <div *ngIf="
                generateRegisterForm.get('email')?.hasError('required') &&
                generateRegisterForm.get('email')?.touched
              " class="text-danger">
              Le champ "email" est obligatoire.
            </div>
            <div *ngIf="
                generateRegisterForm.get('email')?.hasError('pattern') &&
                generateRegisterForm.get('email')?.touched
              " class="text-danger">
              Le format l’adresse mail n'est pas valide.
            </div>
            <!--end::Password-->
          </div>
          <div class="fv-row mb-8">
            <!--begin::Password-->
            <label for="password">Mot de passe <span class="start-required">*</span></label>
            <div class="input-group password-input mb-5">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-lock"></i>
              </span>
              <input [type]="showPassword" id="password" formControlName="password" class="form-control"
                aria-label="password" aria-describedby="basic-addon1" placeholder="Mot de passe" />
              <i ngClass="on" *ngIf="showPassword == 'password'" (click)="showPassword = 'text'"
                class="fa-regular fa-eye-slash"></i>
              <i ngClass="on" *ngIf="showPassword == 'text'" (click)="showPassword = 'password'"
                class="fa-regular fa-eye"></i>
            </div>

            <div *ngIf="
                generateRegisterForm.get('password')?.hasError('pattern') &&
                generateRegisterForm.get('password')?.touched
              " class="text-danger">
              Votre mot de passe doit contenir au minimum 8 caractères dont une
              lettre Maj , une lettre Min et un caractère spécial.
            </div>
            <!--end::Password-->
          </div>

          <div class="fv-row mb-8">
            <!--begin:: Confirm Password-->
            <label for="password">Confirmer mot de passe <span class="start-required">*</span></label>
            <div class="input-group password-input mb-5">
              <span class="input-group-text" id="basic-addon1">
                <i class="fa-solid fa-lock"></i>
              </span>
              <input [type]="showConfirmPassword" id="confirmPassword" formControlName="confirmPassword" class="form-control"
                aria-label="password" aria-describedby="basic-addon1" placeholder="Confirmer mot de passe" />
              <i ngClass="on" *ngIf="showConfirmPassword == 'password'" (click)="showConfirmPassword = 'text'"
                class="fa-regular fa-eye-slash"></i>
              <i ngClass="on" *ngIf="showConfirmPassword == 'text'" (click)="showConfirmPassword = 'password'"
                class="fa-regular fa-eye"></i>
            </div>

            <div *ngIf="generateRegisterForm.get('confirmPassword')?.hasError('mustMatch') &&
                      generateRegisterForm.get('confirmPassword')?.touched"
                      class="text-danger">
                      Les mots de passe ne correspondent pas.
            </div>
            <!--end::Confirm Password-->
          </div>
         

          <div class="check-input form-check mb-8">
            <input
            class="form-check-input"
            type="checkbox"
            formControlName="newsLetter"
            id="checkboxNewsletter"/>
            <div class="label-newsletter" for="checkboxNewsletter">
              <span class="fw-600">Je veux recevoir les news WeGestU.</span>
              <p>Newsletter, conseils & tendances sur le marché de l'emploi, nouvelles fonctionnalités sur mon profil.</p>
            </div>
          </div>
          <div class="check-input form-check mb-8">
            <input
            class="form-check-input"
            type="checkbox"
            formControlName="terme"
            (change)="terms()"
            id="flexCheckDefault"
          />
            <div class="form-check-label" for="flexCheckDefault" class="required">
              J'ai lu et j'accepte les
              <a class="terms" href={{env.cgu_link}} target="_blank">CGU ENTREPRISE </a> ,  <a class="terms" href={{env.cgv_link}} target="_blank">les CGV </a> et
              <a class="terms" href={{env.confidential_policy_link}} target="_blank">la politique de protection des données</a>
            </div>
          </div>

          <!-- <div class="">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="newsLetter"
                id="checkboxNewsletter"
              />
              <div
                class="label-newsletter"
                for="checkboxNewsletter"
              >
                <span class="fw-600">Je veux recevoir les news WeGestU.</span>
                <p>Newsletter, conseils & tendances sur le marché de l'emploi, nouvelles fonctionnalités sur mon profil.</p>
            </div>
            </div>
          </div>
          <div class="">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="terme"
                (change)="terms()"
                id="flexCheckDefault"
              />
              <div
                class="form-check-label"
                for="flexCheckDefault"
                class="required"
              >
                J'ai lu et j'accepte les
                <a
                  class="terms"
                  href={{env.cgu_link}}
                  target="_blank"
                  >CGU</a> et 
                  <a
                  class="terms"
                  href={{env.confidential_policy_link}}
                  target="_blank"
                  >la politique de protection des données</a>
              </div>
            </div>
           
          </div> -->


        
          <div class="mb-8">
            <button class="btn btn-sm btn-primary signup-btn pt-5 pb-5 w-100" (click)="term && generateRegisterForm.valid && signUp()"
              [disabled]="!term ||generateRegisterForm.invalid">
              S’inscrire
            </button>
          </div>
          <div class="mb-8 text-center">
            <span>Vous avez déjà un compte? </span>
            <a href="/" class="signin">Connectez-vous</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center">
  <app-footer-unauthenticated></app-footer-unauthenticated>
</div>